import { useEffect, useMemo } from 'react';

import { Neighbors } from '@/utils/shared/toNeighbors';

type UseNeighborsParams<T> = {
  items: T[];
  isInitialLoading: boolean;
  hasNextPage?: boolean;
  fetchNextPage(): unknown;
  resolve(items: T[]): Neighbors<T>;
};

export default function useNeighbors<T>({
  items,
  isInitialLoading,
  hasNextPage,
  fetchNextPage,
  resolve,
}: UseNeighborsParams<T>) {
  const { previous, next, isResolved } = useMemo(
    () => resolve(items),
    [items, resolve],
  );

  const loadedCount = items.length;

  useEffect(() => {
    if (!isResolved && hasNextPage) fetchNextPage();
  }, [isResolved, hasNextPage, fetchNextPage, loadedCount]);

  return {
    previous,
    next,
    isLoading: isInitialLoading || (!isResolved && !!hasNextPage),
  };
}
